module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Bold.cad9c148.svg";